import * as S from './style';

function FirstGradient() {
    return (
        <S.FirstGradient xmlns="http://www.w3.org/2000/svg" width="792" height="824" viewBox="0 0 792 824" fill="none">
            <g filter="url(#filter0_f_308_496)">
                <path fillRule="evenodd" clipRule="evenodd" d="M-17.1371 662.156C-422.929 -618.109 -910.51 -401.669 -749.431 492.905L-526.267 492.905C-1105.02 -916.847 -36.9967 -847.29 492 662.156C315.464 767.417 203.231 764.468 -17.1371 662.156Z" fill="url(#paint0_linear_308_496)" fillOpacity="0.53"/>
            </g>
            <defs>
                <filter id="filter0_f_308_496" x="-1081" y="-819" width="1873" height="1859" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feGaussianBlur stdDeviation="150" result="effect1_foregroundBlur_308_496"/>
                </filter>
                <linearGradient id="paint0_linear_308_496" x1="-781" y1="-518.999" x2="-781" y2="662.157" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#00AAFF"/>
                    <stop offset="0.5" stopColor="#1DD59F"/>
                    <stop offset="1" stopColor="#339336"/>
                </linearGradient>
            </defs>
        </S.FirstGradient>
    )
}

export default FirstGradient;